import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { checkAuth } from './apiClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  const checkAuthStatus = useCallback(async () => {
    const auth = await checkAuth();
    setIsAuthenticated(auth.authenticated);
    //console.log('auth', auth);
  }, []);

  useEffect(() => {
    checkAuthStatus();
  }, [checkAuthStatus]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated, checkAuthStatus }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
